var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"solution c-width"},[_c('el-image',{attrs:{"src":_vm.src,"alt":"","lazy":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }